/* eslint-disable no-unused-expressions */
import axios from "axios";
import Vue from "vue";
// import { Toast } from "cube-ui";
import { Toast } from "mint-ui";
import { updateSession, getSessionInfo, setSessionByWeb, getSessionByWeb } from "./session";
// console.log(updateSession)
// Vue.use(Toast);
import "mint-ui/lib/toast/style.css";

import i18n from "@/tools/i18n";

function showToast(txt) {
  // const toast = Toast.$create({
  //   type: "text",
  //   txt
  // });
  // toast.show();
  Toast(txt);
}

// const { updateSession, getSessionInfo } = session;

function transformPostData(data, type) {
  let params;
  if (type === "post") {
    const dataArr = [];
    Object.keys(data).forEach(key => {
      dataArr.push(`${key}=${data[key]}`);
    });
    params = dataArr.join("&");
  } else {
    params = { params: data };
  }
  return params;
}

// function canMock() {
//   if (ENV === 'DEV'
//     && !(/\.56qq\.([com]||[cn])/).test(window.location.hostname)) {
//     return true;
//   }
//   return false;
// }

function getAxios(option) {
  const { timeout, host, api } = option;
  let request;
  let url;
  // if (canMock() && useMock) {
  //   request = axios.create({
  //     timeout,
  //     headers: { 'Host-Proxy': host }
  //   });
  //   url = api;
  // } else {
  request = axios.create({
    timeout,
  });
  url = host + api;
  // }
  return {
    request,
    url
  };
}

/**
 * http
 * 参数：
 *  {String} {required} host：接口域名
 *  {Array} authorityFailureCodes：session下线错误码
 *  {Object} 其他参数
 *    {Boolean} useMock：是否开启mock
 *    {Number} timeout：超时时间，默认20000
 * 方法：
 *  post：带session post请求
 *  get：带session get请求
 *  postFree：post请求
 *  getFree：get请求
 */
class Http {
  constructor(host = "", authorityFailureCodes = [], option = {}) {
    this.host = host;
    this.authorityFailureCodes = authorityFailureCodes;
    this.option = {
      useMock: false,
      timeout: 20000,
      ...option
    };
    this.post = this.post.bind(this);
    this.get = this.get.bind(this);
    this.postFree = this.postFree.bind(this);
    this.getFree = this.getFree.bind(this);
    this.sso = this.sso.bind(this);
    this.free = this.free.bind(this);
    this.ssoWeb = this.ssoWeb.bind(this);
    this.postWeb = this.postWeb.bind(this);
  }

  get(api = "", data = {}, option = {}) {
    return this.sso({
      api,
      data,
      option,
      type: "get",
      isDo: false
    });
  }

  post(api = "", data = {}, option = {}) {
    return this.sso({
      api,
      data,
      option,
      type: "post",
      isDo: false
    });
  }

  getFree(api = "", data = {}, option = {}) {
    return this.free({
      api,
      data,
      option,
      type: "get"
    });
  }

  postFree(api = "", data = {}, option = {}) {
    return this.free({
      api,
      data,
      option,
      type: "post"
    });
  }

  postWeb(api = "", data = {}, option = {}) {
    return this.ssoWeb({
      api,
      data,
      option,
      type: 'post',
    })
  }

  sso(params) {
    return new Promise((resolve, reject) => {
      const { api, option, type, isDo } = params;
      let { data } = params;
      const session = getSessionInfo();
      // 请求参数加入st、sid
      data = {
        // _tk_: session.st,
        // _deviceId_: session.sid,
        ...data
      };
      const { request, url } = getAxios({
        timeout: option.timeout || this.option.timeout,
        host: this.host,
        api,
        useMock: option.useMock === false ? false : option.useMock || this.option.useMock
      });
      return request[type](url, transformPostData(data, type), {
        // 统一将sso信息加入到header头中
        headers: {
          "_Token_": session.st,
          "_Device-Id_": session.sid,
        }
      }).then(
        async response => {
          if (response.data.status.toUpperCase() === "ERROR") {
            // 如果是session下线，并且没有更新过session，就更新session，并重新执行
            if (this.authorityFailureCodes.includes(response.data.errorCode.toString()) && !isDo) {
              // await getSessionByWeb();
              await updateSession();
              return this.sso(
                Object.assign(params, {
                  isDo: true
                })
              ).then(
                resp => {
                  resolve(resp);
                },
                resp => {
                  return reject(resp);
                }
              );
            } else {
              if (!option.closeTips && response.data.errorMsg) {
                showToast(response.data.errorMsg);
              }
              return reject(response.data);
            }
          } else {
            resolve(response.data.content);
          }
        },
        e => {
          showToast(i18n.t("common.exceptionText"));
          return reject({ status: "FAIL", errorMsg: i18n.t("common.apiErrorText") }, e);
        }
      );
    });
  }

  ssoWeb(params) {
    return new Promise((resolve, reject) => {
      const { api, option, type, isDo } = params;
      let { data } = params;

      setSessionByWeb().then(() => {
        const session = getSessionInfo();
        const { request, url } = getAxios({
          timeout: option.timeout || this.option.timeout,
          host: this.host,
          api,
          useMock: option.useMock === false ? false : option.useMock || this.option.useMock
        });

        return request[type](url, transformPostData(data, type), {
          // 统一将sso信息加入到header头中
          headers: {
            "_Token_": session.st,
            "_Device-Id_": session.sid,
          }
        }).then(
          async response => {
            if (response.data.status.toUpperCase() === "ERROR") {
              // 如果是session下线，并且没有更新过session，就更新session，并重新执行
              if (this.authorityFailureCodes.includes(response.data.errorCode.toString()) && !isDo) {
                return reject(response);
              } else {
                if (!option.closeTips && response.data.errorMsg) {
                  showToast(response.data.errorMsg);
                }
                return reject(response.data);
              }
            } else {
              resolve(response.data.content);
            }
          },
          e => {
            showToast(i18n.t("common.exceptionText"));
            return reject({ status: "FAIL", errorMsg: i18n.t("common.apiErrorText") }, e);
          }
        );
      })
    });
  }

  free(params) {
    return new Promise((resolve, reject) => {
      const { api, data, option, type } = params;
      const { request, url } = getAxios({
        timeout: option.timeout || this.option.timeout,
        host: this.host,
        api,
        useMock: option.useMock === false ? false : option.useMock || this.option.useMock
      });
      return request[type](url, transformPostData(data, type)).then(
        async response => {
          if (
            response.data.status &&
            typeof response.data.status === "string" &&
            response.data.status.toUpperCase() === "ERROR"
          ) {
            if (!option.closeTips && response.data.errorMsg) {
              showToast(response.data.errorMsg);
            }
            return reject(response.data);
          } else {
            resolve(response.data.content);
          }
        },
        e => {
          showToast(i18n.t("common.exceptionText"));
          return reject({ status: "FAIL", errorMsg: i18n.t("common.apiErrorText") }, e);
        }
      );
    });
  }
}

export default Http;
